import { createContext, useContext } from 'react';
import type { SourceKind } from './types';

export interface OpenFactArgs {
  id: string;
  title?: string | undefined;
  sources?: SourceKind[] | undefined;
}

export interface InsuranceCtx {
  openFact: (args: OpenFactArgs) => void;
  openCall: () => void;
  openPortal: () => void;
  scrollTo: (anchorId: string) => void;
}

const Ctx = createContext<InsuranceCtx | null>(null);
export const InsuranceProvider = Ctx.Provider;

export function useInsurance(): InsuranceCtx {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useInsurance must be used inside an InsuranceProvider');
  return ctx;
}
